import * as React from "react";
import { DateHelper } from "../../../../../../react-core/Helpers/DateHelper";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Lightbox, LightboxType } from "../../../../../../react-core/Html/Components/Lightbox";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { RegularDrawdown } from "../../../../../../Wrap/Models/Domains/Drawdown/RegularDrawdown";
import { MoneyHelper } from "../../../../../Shared/Common/MoneyHelper";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { FrequencyTypeMap } from "../../../../Resoures/Contents";
import { getAnnualIncomeBasedOnFrequency } from "../../GadReviewWizard/Resource/Helper";
import { regularCrystallisationContent } from "../Resource/Contents";
import { addDays, stripToDay } from "../../../../../../react-core/utils/date";

interface IReviewProps extends IProcessComponentProps {
    data: any;
    isSubmitting: boolean;
    showLightbox: boolean;
    isActive: boolean;
    setShowLightbox: (show: boolean) => void;
    onConfirm: () => void;
}

export class CurrentSummary extends ProcessComponent<IReviewProps, null> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { data, isActive, isSubmitting, showLightbox } = this.props;
        const regularCrystallisationData = data as RegularDrawdown;

        if (!data) {
            return <PartLoading isLoading={true} />;
        }

        const annualIncome = getAnnualIncomeBasedOnFrequency(
            regularCrystallisationData.IncomeRequired,
            regularCrystallisationData.Frequency
        );
        const pcls = MoneyHelper.multiplyBy(regularCrystallisationData.ProposedCrystallisation.Amount, 0.25);
        return (
            <div>
                {showLightbox && this.renderConfirmPopup()}
                <div className="col-md-10 col-12">
                    <h1>{regularCrystallisationContent.summaryTitle}</h1>

                    <table className={"simple-table mt-30"}>
                        <tbody>
                            {this.renderRow(
                                regularCrystallisationContent.amount,
                                MoneyDisplayHelper.getMoneyFormat(regularCrystallisationData.ProposedCrystallisation)
                            )}

                            {this.renderRow(
                                regularCrystallisationContent.frequency,
                                FrequencyTypeMap[regularCrystallisationData.Frequency]
                            )}

                            {this.renderRow(
                                regularCrystallisationContent.date,
                                DateHelper.getDateStringAsddmmmyyyy(
                                    JsonDateParser.toDate(regularCrystallisationData.NextPaymentDate)
                                )
                            )}

                            {this.renderRow(
                                regularCrystallisationContent.pcls,
                                MoneyDisplayHelper.getMoneyFormat(pcls)
                            )}

                            {this.renderRow(
                                regularCrystallisationContent.income,
                                MoneyDisplayHelper.getMoneyFormat(regularCrystallisationData.IncomeRequired)
                            )}

                            {this.renderRow(
                                regularCrystallisationContent.annualIncome,
                                MoneyDisplayHelper.getMoneyFormat(annualIncome)
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="process-aside">
                    <div className="process-aside-content">
                        <div className="page-actions">
                            <div className="action-primary">
                                <button
                                    disabled={!isActive}
                                    onClick={() =>
                                        isSubmitting || showLightbox ? null : this.props.setShowLightbox(true)
                                    }
                                    className={`next-button ${isSubmitting ? "btn is-busy" : ""}`}
                                >
                                    <span aria-hidden="true" className="icon"></span>
                                    <span className="text">{regularCrystallisationContent.cancelButton}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderRow(description: string, value: string): JSX.Element {
        return (
            <tr>
                <td className="text-bold">{description}</td>
                <td>{value}</td>
            </tr>
        );
    }

    private isShowInProgressWarning(): boolean {
        const nextPaymentDate = stripToDay(new Date(this.props.data.NextPaymentDate))
        const today = stripToDay(new Date())
        return today >= addDays(nextPaymentDate, -5)
    }

    private renderConfirmPopup(): JSX.Element {
        return (
            <Lightbox
                show={this.props.showLightbox}
                title={""}
                onClose={() => this.props.setShowLightbox(false)}
                type={LightboxType.Modal}
                unclosable={false}
                noOverlay={false}
                noAutofocus={true}
                cssWrapper="is-default-lightbox is-narrow"
            >
                {!this.isShowInProgressWarning() && (<div className="row row-center">
                    <h3>{regularCrystallisationContent.lightboxMessage}</h3>
                </div>)}
                {this.isShowInProgressWarning() && (<div className="row row-center">
                    <h4>{regularCrystallisationContent.inProgressWarning}</h4>
                </div>)}
                <div className="row row-center mt-30">
                    <div className="col-3">
                        <button className="btn primary" onClick={() => this.props.onConfirm()}>
                            Yes
                        </button>
                    </div>

                    <div className="col-3">
                        <button className="btn secondary mr-4" onClick={() => this.props.setShowLightbox(false)}>
                            No
                        </button>
                    </div>
                </div>
            </Lightbox>
        );
    }
}
